export default __webpack_public_path__ + "static/media/filter.99a0d780.svg";